// extracted by mini-css-extract-plugin
export default {"button":"Buttons_button__2PV1L","filled":"Buttons_filled__l+4fQ","outlined":"Buttons_outlined__KIxEE"};